// src/js/pages/manager-requests.ts

import { registerPageInit } from '../barba/page-init-registry';
import '../../css/_root.scss';
import '../../css/pages/personal-area/manager-requests.scss';

import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import { createApp } from 'vue';

// Основные компоненты
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import Dialog from 'primevue/dialog';
import Select from 'primevue/select';
import TabPanel from 'primevue/tabpanel';

// Сервисы
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';

import 'primeicons/primeicons.css';

import ManagerRequestsApp from '../widgets/manager-requests/index.vue';
import Tabs from 'primevue/tabs';
import { Tab, TabList, TabPanels } from 'primevue';
import { initLkMobileNotice } from '../widgets/lk-mobile-notice';

class ManagerRequestsPage {
  public init(): void {
    initLkMobileNotice();

    const el = document.getElementById('manager-requests-app');
    if (!el) return;

    const app = createApp(ManagerRequestsApp);

    app.use(PrimeVue, {
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
        },
      },
    });
    app.use(ToastService);
    app.use(ConfirmationService);

    // Регистрация компонентов
    app.component('DataTable', DataTable);
    app.component('Column', Column);
    app.component('Button', Button);
    app.component('Textarea', Textarea);
    app.component('Toast', Toast);
    app.component('ConfirmDialog', ConfirmDialog);
    app.component('Dialog', Dialog);
    app.component('Select', Select);
    app.component('TabPanel', TabPanel);
    app.component('Tabs', Tabs);
    app.component('TabList', TabList);
    app.component('Tab', Tab);
    app.component('TabPanels', TabPanels);
    app.component('TabPanel', TabPanel);

    app.mount(el);
  }
}

registerPageInit('manager-requests', () => {
  const page = new ManagerRequestsPage();
  page.init();
});
